import Fetch, { V1 } from 'Util/fetcher';

const SET_FUND_DETAIL = 'SET_FUND_DETAIL';
const RESET_FUND_DETAIL = 'RESET_FUND_DETAIL';
const SET_FUND_CHART = 'SET_FUND_CHART';
const ON_COLLECTED_COMPARE = 'ON_COLLECTED_COMPARE';
const ON_COLLECTED_DETAIL_COMPARE = 'ON_COLLECTED_DETAIL_COMPARE';

function onDoSetFundDetail(payload) {
    return {
        type: SET_FUND_DETAIL,
        payload
    };
}

function onDoReSetFundDetail() {
    return {
        type: RESET_FUND_DETAIL,
    };
}

function onDoSetChartFund(payload) {
    return {
        type: SET_FUND_CHART,
        payload
    };
}

export const onDoRequestChart = payload => (dispatch) => {
    const fundTempDetail = [];
    payload.map(v => fundTempDetail.push(`${V1}common/funds/${v}/chart/`));
    Promise.all(
        fundTempDetail.map(u => Fetch.get(u))
    ).then(responses => 
        Promise.all(responses.map(res => res.json))).then((resp) => {
            dispatch(onDoSetChartFund(resp));
    });
};

export const onDoRequestThemeDetail = payload => (dispatch) => {
    dispatch(onDoReSetFundDetail());
    const fundTempDetail = [];
    const fundTempChart = [];
    payload.map(v => fundTempDetail.push(`${V1}common/funds/fund-bundle/${v}/`));
    Promise.all(
        fundTempDetail.map(u => Fetch.get(u))
    ).then(responses => 
        Promise.all(responses.map(res => res.json))).then((resp) => {
            resp.forEach(v => fundTempChart.push(v.fund[0].id));
            dispatch(onDoRequestChart(fundTempChart));
            dispatch(onDoSetFundDetail(resp));
    });
};

export function onCollectedCompare(payload) {
    return {
        type: ON_COLLECTED_COMPARE,
        payload
    };
}

export function onCollectedDetailCompare(payload) {
    return {
        type: ON_COLLECTED_DETAIL_COMPARE,
        payload
    };
}


const INITIAL_STATE = {
    fundCompare: [],
    chartCompare: [],
    collectedCompare: null,
    collectedDetailCompare: null,
};

const compareFund = (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case SET_FUND_DETAIL: {
            return {
                ...state,
                fundCompare: [...action.payload]
            };
        }
        case RESET_FUND_DETAIL: {
            return {
                ...state,
                fundCompare: []
            };
        }
        case SET_FUND_CHART: {
            return {
                ...state,
                chartCompare: [...action.payload]
            };
        }
        case ON_COLLECTED_COMPARE: {
            return {
                ...state,
                collectedCompare: action.payload
            };
        }
        case ON_COLLECTED_DETAIL_COMPARE: {
            return {
                ...state,
                collectedDetailCompare: action.payload
            };
        }
        default:
            return state;
    }
};

export default compareFund;
